import { Collections } from "./shop.types";

const initialCollections: Collections = {
  petCollection: {
    id: "",
    title: "",
    path: "",
    collections: [],
  },
  justInCollection: {
    id: "",
    title: "",
    path: "",
    collections: [],
  },
  specialCollection: {
    id: "",
    title: "",
    path: "",
    collections: [],
  },
  justInPreview: [],
  specialPreview: [],

  // {
  //   id: 'dog',
  //   title: 'dog',
  //   path: 'dog',
  //   subPetCollections: [
  //     {
  //       id: 'food',
  //       title: 'food',
  //       path: 'food',
  //       items: [],
  //     },
  //     {
  //       id: 'treats',
  //       title: 'treats',
  //       path: 'treats',
  //       items: [],
  //     },
  //     {
  //       id: 'supplies',
  //       title: 'supplies',
  //       path: 'supplies',
  //       items: [],
  //     },
  //   ],
  // },
  // {
  //   id: 'cat',
  //   title: 'cat',
  //   path: 'cat',
  //   subPetCollections: [
  //     {
  //       id: 'food',
  //       title: 'food',
  //       path: 'food',
  //       items: [],
  //     },
  //     {
  //       id: 'litterAndAccessories',
  //       title: 'litter & accessories',
  //       path: 'litter-and-accessories',
  //       items: [],
  //     },
  //     {
  //       id: 'treats',
  //       title: 'treats',
  //       path: 'treats',
  //       items: [],
  //     },
  //   ],
  // },
  // {
  //   id: 'bird',
  //   title: 'bird',
  //   path: 'bird',
  //   subPetCollections: [
  //     {
  //       id: 'food',
  //       title: 'food',
  //       path: 'food',
  //       items: [],
  //     },
  //     {
  //       id: 'treats',
  //       title: 'treats',
  //       path: 'treats',
  //       items: [],
  //     },
  //     {
  //       id: 'supplies',
  //       title: 'supplies',
  //       path: 'supplies',
  //       items: [],
  //     },
  //   ],
  // },
  // {
  //   id: 'reptile',
  //   title: 'reptile',
  //   path: 'reptile',
  //   subPetCollections: [
  //     {
  //       id: 'food',
  //       title: 'food',
  //       path: 'food',
  //       items: [],
  //     },
  //     {
  //       id: 'treats',
  //       title: 'treats',
  //       path: 'treats',
  //       items: [],
  //     },
  //     {
  //       id: 'supplies',
  //       title: 'supplies',
  //       path: 'supplies',
  //       items: [],
  //     },
  //   ],
  // },
  // {
  //   id: 'smallpets',
  //   title: 'small pets',
  //   path: 'small-pets',
  //   subPetCollections: [
  //     {
  //       id: 'food',
  //       title: 'food',
  //       path: 'food',
  //       items: [],
  //     },
  //     {
  //       id: 'treats',
  //       title: 'treats',
  //       path: 'treats',
  //       items: [],
  //     },
  //     {
  //       id: 'supplies',
  //       title: 'supplies',
  //       path: 'supplies',
  //       items: [],
  //     },
  //   ],
  // },
  // {
  //   id: 'fish',
  //   title: 'fish',
  //   path: 'fish',
  //   subPetCollections: [
  //     {
  //       id: 'food',
  //       title: 'food',
  //       path: 'food',
  //       items: [],
  //     },
  //     {
  //       id: 'care',
  //       title: 'care',
  //       path: 'care',
  //       items: [],
  //     },
  //     {
  //       id: 'supplies',
  //       title: 'supplies',
  //       path: 'supplies',
  //       items: [],
  //     },
  //   ],
  // },
  // ],
};

// const collections: Collections = {
//   petCollections: [
//     {
//       id: 'dog',
//       title: 'dog',
//       path: 'dog',
//       subPetCollections: [
//         {
//           id: 'food',
//           title: 'food',
//           path: 'dog/food',
//           items: [
//             {
//               id: nanoid(),
//               mainCollectionId: 'dog',
//               subCollectionId: 'food',
//               category: 'dry food',
//               name: 'dog dry food 1',
//               price: 10,
//               brand: 'ABC',
//               shortDescription: 'Awesome!',
//               dateAdded: new Date('2021-01-01'),
//               isSoldOut: false,
//               isPopular: false,
//               isOnSale: false,
//             },
//             {
//               id: nanoid(),
//               mainCollectionId: 'dog',
//               subCollectionId: 'food',
//               category: 'dry food',
//               name: 'dog dry food 2',
//               price: 12,
//               brand: 'BCD',
//               shortDescription: 'Awesome!',
//               dateAdded: new Date('2021-01-01'),
//               isSoldOut: false,
//               isPopular: false,
//               isOnSale: false,
//             },
//             {
//               id: nanoid(),
//               mainCollectionId: 'dog',
//               subCollectionId: 'food',
//               category: 'dry food',
//               name: 'dog dry food 3',
//               price: 8,
//               brand: 'CDE',
//               shortDescription: 'Awesome!',
//               dateAdded: new Date('2021-01-01'),
//               isSoldOut: false,
//               isPopular: false,
//               isOnSale: false,
//             },
//             {
//               id: nanoid(),
//               mainCollectionId: 'dog',
//               subCollectionId: 'food',
//               category: 'dry food',
//               name: 'dog dry food 4',
//               price: 16,
//               brand: 'DEF',
//               shortDescription: 'Awesome!',
//               dateAdded: new Date('2021-01-01'),
//               isSoldOut: false,
//               isPopular: false,
//               isOnSale: false,
//             },
//             {
//               id: nanoid(),
//               mainCollectionId: 'dog',
//               subCollectionId: 'food',
//               category: 'dry food',
//               name: 'dog dry food 5',
//               price: 20,
//               brand: 'EFG',
//               shortDescription: 'Awesome!',
//               dateAdded: new Date('2021-01-01'),
//               isSoldOut: false,
//               isPopular: false,
//               isOnSale: false,
//             },
//             {
//               id: nanoid(),
//               mainCollectionId: 'dog',
//               subCollectionId: 'food',
//               category: 'wet food',
//               name: 'dog wet food 1',
//               price: 10,
//               brand: 'FGH',
//               shortDescription: 'Awesome!',
//               dateAdded: new Date('2021-01-01'),
//               isSoldOut: false,
//               isPopular: false,
//               isOnSale: false,
//             },
//             {
//               id: nanoid(),
//               mainCollectionId: 'dog',
//               subCollectionId: 'food',
//               category: 'food toppers',
//               name: 'dog food toppers 1',
//               price: 12,
//               brand: 'GHI',
//               shortDescription: 'Awesome!',
//               dateAdded: new Date('2020-09-01'),
//               isSoldOut: false,
//               isPopular: false,
//               isOnSale: false,
//             },
//             {
//               id: nanoid(),
//               mainCollectionId: 'dog',
//               subCollectionId: 'food',
//               category: 'food toppers',
//               name: 'dog food toppers 2',
//               price: 14,
//               brand: 'HIJ',
//               shortDescription: 'Awesome!',
//               dateAdded: new Date('2020-09-01'),
//               isSoldOut: false,
//               isPopular: false,
//               isOnSale: false,
//             },
//             {
//               id: nanoid(),
//               mainCollectionId: 'dog',
//               subCollectionId: 'food',
//               category: 'food toppers',
//               name: 'dog food toppers 3',
//               price: 17,
//               brand: 'IJK',
//               shortDescription: 'Awesome!',
//               dateAdded: new Date('2020-09-01'),
//               isSoldOut: false,
//               isPopular: false,
//               isOnSale: false,
//             },
//             {
//               id: nanoid(),
//               mainCollectionId: 'dog',
//               subCollectionId: 'food',
//               category: 'food toppers',
//               name: 'dog food toppers 4',
//               price: 15,
//               brand: 'JKL',
//               shortDescription: 'Awesome!',
//               dateAdded: new Date('2020-09-01'),
//               isSoldOut: false,
//               isPopular: false,
//               isOnSale: false,
//             },
//           ],
//         },
//         {
//           id: 'treats',
//           title: 'treats',
//           path: 'dog/treats',
//           items: [
//             {
//               id: nanoid(),
//               mainCollectionId: 'dog',
//               subCollectionId: 'treats',
//               category: 'biscuits',
//               name: 'dog biscuit 1',
//               price: 12,
//               brand: 'KLM',
//               shortDescription: 'Awesome!',
//               dateAdded: new Date('2020-06-01'),
//               isSoldOut: false,
//               isPopular: false,
//               isOnSale: false,
//             },
//             {
//               id: nanoid(),
//               mainCollectionId: 'dog',
//               subCollectionId: 'treats',
//               category: 'biscuits',
//               name: 'dog biscuit 2',
//               price: 14,
//               brand: 'LMN',
//               shortDescription: 'Awesome!',
//               dateAdded: new Date('2020-06-01'),
//               isSoldOut: false,
//               isPopular: false,
//               isOnSale: false,
//             },
//             {
//               id: nanoid(),
//               mainCollectionId: 'dog',
//               subCollectionId: 'treats',
//               category: 'bone sticks',
//               name: 'dog bone stick 1',
//               price: 8,
//               brand: 'MNO',
//               shortDescription: 'Awesome!',
//               dateAdded: new Date('2020-06-01'),
//               isSoldOut: false,
//               isPopular: false,
//               isOnSale: false,
//             },
//             {
//               id: nanoid(),
//               mainCollectionId: 'dog',
//               subCollectionId: 'treats',
//               category: 'bone sticks',
//               name: 'dog bone stick 2',
//               price: 10,
//               brand: 'NOP',
//               shortDescription: 'Awesome!',
//               dateAdded: new Date('2020-06-01'),
//               isSoldOut: false,
//               isPopular: false,
//               isOnSale: false,
//             },
//             {
//               id: nanoid(),
//               mainCollectionId: 'dog',
//               subCollectionId: 'treats',
//               category: 'dental treats',
//               name: 'dog dental treats 1',
//               price: 8,
//               brand: 'OPQ',
//               shortDescription: 'Awesome!',
//               dateAdded: new Date('2020-06-01'),
//               isSoldOut: false,
//               isPopular: false,
//               isOnSale: false,
//             },
//             {
//               id: nanoid(),
//               mainCollectionId: 'dog',
//               subCollectionId: 'treats',
//               category: 'dental treats',
//               name: 'dog dental treats 2',
//               price: 10,
//               brand: 'PQR',
//               shortDescription: 'Awesome!',
//               dateAdded: new Date('2021-02-15'),
//               isSoldOut: false,
//               isPopular: false,
//               isOnSale: false,
//             },
//           ],
//         },
//         {
//           id: 'supplies',
//           title: 'supplies',
//           path: 'dog/supplies',
//           items: [],
//         },
//       ],
//     },
//     {
//       id: 'cat',
//       title: 'cat',
//       path: 'cat',
//       subPetCollections: [
//         {
//           id: 'food',
//           title: 'food',
//           path: 'cat/food',
//           items: [
//             {
//               id: nanoid(),
//               mainCollectionId: 'cat',
//               subCollectionId: 'food',
//               category: 'wet food',
//               name: 'cat wet food 1',
//               price: 10,
//               brand: 'QRS',
//               shortDescription: 'Awesome!',
//               dateAdded: new Date('2021-02-15'),
//               isSoldOut: false,
//               isPopular: false,
//               isOnSale: false,
//             },
//             {
//               id: nanoid(),
//               mainCollectionId: 'cat',
//               subCollectionId: 'food',
//               category: 'wet food',
//               name: 'cat wet food 2',
//               price: 12,
//               brand: 'RST',
//               shortDescription: 'Awesome!',
//               dateAdded: new Date('2021-02-15'),
//               isSoldOut: false,
//               isPopular: false,
//               isOnSale: false,
//             },
//             {
//               id: nanoid(),
//               mainCollectionId: 'cat',
//               subCollectionId: 'food',
//               category: 'wet food',
//               name: 'cat wet food 3',
//               price: 8,
//               brand: 'STU',
//               shortDescription: 'Awesome!',
//               dateAdded: new Date('2021-02-15'),
//               isSoldOut: false,
//               isPopular: false,
//               isOnSale: false,
//             },
//             {
//               id: nanoid(),
//               mainCollectionId: 'cat',
//               subCollectionId: 'food',
//               category: 'wet food',
//               name: 'cat wet food 4',
//               price: 16,
//               brand: 'TUV',
//               shortDescription: 'Awesome!',
//               dateAdded: new Date('2021-02-15'),
//               isSoldOut: false,
//               isPopular: false,
//               isOnSale: false,
//             },
//             {
//               id: nanoid(),
//               mainCollectionId: 'cat',
//               subCollectionId: 'food',
//               category: 'dry food',
//               name: 'cat dry food 1',
//               price: 10,
//               brand: 'UVW',
//               shortDescription: 'Awesome!',
//               dateAdded: new Date('2021-02-24'),
//               isSoldOut: false,
//               isPopular: false,
//               isOnSale: false,
//             },
//             {
//               id: nanoid(),
//               mainCollectionId: 'cat',
//               subCollectionId: 'food',
//               category: 'dry food',
//               name: 'cat dry food 2',
//               price: 12,
//               brand: 'VWX',
//               shortDescription: 'Awesome!',
//               dateAdded: new Date('2021-02-24'),
//               isSoldOut: false,
//               isPopular: false,
//               isOnSale: false,
//             },
//             {
//               id: nanoid(),
//               mainCollectionId: 'cat',
//               subCollectionId: 'food',
//               category: 'dry food',
//               name: 'cat dry food 3',
//               price: 15,
//               brand: 'WXY',
//               shortDescription: 'Awesome!',
//               dateAdded: new Date('2021-02-24'),
//               isSoldOut: false,
//               isPopular: false,
//               isOnSale: false,
//             },
//           ],
//         },
//         {
//           id: 'litterAndAccessories',
//           title: 'litter & accessories',
//           path: 'cat/litter-and-accessories',
//           items: [],
//         },
//         {
//           id: 'treats',
//           title: 'treats',
//           path: 'cat/treats',
//           items: [],
//         },
//       ],
//     },
//     {
//       id: 'bird',
//       title: 'bird',
//       path: 'bird',
//       subPetCollections: [
//         {
//           id: 'food',
//           title: 'food',
//           path: 'bird/food',
//           items: [],
//         },
//         {
//           id: 'treats',
//           title: 'treats',
//           path: 'bird/treats',
//           items: [],
//         },
//         {
//           id: 'supplies',
//           title: 'supplies',
//           path: 'bird/supplies',
//           items: [
//             {
//               id: nanoid(),
//               mainCollectionId: 'bird',
//               subCollectionId: 'supplies',
//               category: 'feeders',
//               name: 'bird feeder 1',
//               price: 10,
//               brand: 'XYZ',
//               shortDescription: 'Awesome!',
//               dateAdded: new Date('2021-02-24'),
//               isSoldOut: false,
//               isPopular: false,
//               isOnSale: false,
//             },
//             {
//               id: nanoid(),
//               mainCollectionId: 'bird',
//               subCollectionId: 'supplies',
//               category: 'feeders',
//               name: 'bird feeder 2',
//               price: 12,
//               brand: 'YZ1',
//               shortDescription: 'Awesome!',
//               dateAdded: new Date('2021-02-24'),
//               isSoldOut: false,
//               isPopular: false,
//               isOnSale: false,
//             },
//             {
//               id: nanoid(),
//               mainCollectionId: 'bird',
//               subCollectionId: 'supplies',
//               category: 'feeders',
//               name: 'bird feeder 3',
//               price: 8,
//               brand: 'Z12',
//               shortDescription: 'Awesome!',
//               dateAdded: new Date('2021-02-24'),
//               isSoldOut: false,
//               isPopular: false,
//               isOnSale: false,
//             },
//             {
//               id: nanoid(),
//               mainCollectionId: 'bird',
//               subCollectionId: 'supplies',
//               category: 'feeders',
//               name: 'bird feeder 4',
//               price: 16,
//               brand: '123',
//               shortDescription: 'Awesome!',
//               dateAdded: new Date('2020-12-24'),
//               isSoldOut: false,
//               isPopular: false,
//               isOnSale: false,
//             },
//             {
//               id: nanoid(),
//               mainCollectionId: 'bird',
//               subCollectionId: 'supplies',
//               category: 'feeders',
//               name: 'bird feeder 5',
//               price: 20,
//               brand: '234',
//               shortDescription: 'Awesome!',
//               dateAdded: new Date('2020-12-24'),
//               isSoldOut: false,
//               isPopular: false,
//               isOnSale: false,
//             },
//           ],
//         },
//       ],
//     },
//     {
//       id: 'reptile',
//       title: 'reptile',
//       path: 'reptile',
//       subPetCollections: [
//         {
//           id: 'food',
//           title: 'food',
//           path: 'reptile/food',
//           items: [],
//         },
//         {
//           id: 'treats',
//           title: 'treats',
//           path: 'reptile/treats',
//           items: [],
//         },
//         {
//           id: 'supplies',
//           title: 'supplies',
//           path: 'reptile/supplies',
//           items: [],
//         },
//       ],
//     },
//     {
//       id: 'smallPets',
//       title: 'small pets',
//       path: 'small-pets',
//       subPetCollections: [
//         {
//           id: 'food',
//           title: 'food',
//           path: 'small-pets/food',
//           items: [
//             {
//               id: nanoid(),
//               mainCollectionId: 'smallPets',
//               subCollectionId: 'food',
//               category: 'hay',
//               name: 'small pet hay 1',
//               price: 10,
//               brand: '345',
//               shortDescription: 'Awesome!',
//               dateAdded: new Date('2020-12-24'),
//               isSoldOut: false,
//               isPopular: false,
//               isOnSale: false,
//             },
//             {
//               id: nanoid(),
//               mainCollectionId: 'smallPets',
//               subCollectionId: 'food',
//               category: 'hay',
//               name: 'small pet hay 2',
//               price: 12,
//               brand: '456',
//               shortDescription: 'Awesome!',
//               dateAdded: new Date('2020-12-24'),
//               isSoldOut: false,
//               isPopular: false,
//               isOnSale: false,
//             },
//             {
//               id: nanoid(),
//               mainCollectionId: 'smallPets',
//               subCollectionId: 'food',
//               category: 'hay',
//               name: 'small pet hay 3',
//               price: 8,
//               brand: '567',
//               shortDescription: 'Awesome!',
//               dateAdded: new Date('2020-11-20'),
//               isSoldOut: false,
//               isPopular: false,
//               isOnSale: false,
//             },
//             {
//               id: nanoid(),
//               mainCollectionId: 'smallPets',
//               subCollectionId: 'food',
//               category: 'hay',
//               name: 'small pet hay 4',
//               price: 16,
//               brand: '678',
//               shortDescription: 'Awesome!',
//               dateAdded: new Date('2020-11-20'),
//               isSoldOut: false,
//               isPopular: false,
//               isOnSale: false,
//             },
//             {
//               id: nanoid(),
//               mainCollectionId: 'smallPets',
//               subCollectionId: 'food',
//               category: 'hay',
//               name: 'small pet hay 5',
//               price: 20,
//               brand: '789',
//               shortDescription: 'Awesome!',
//               dateAdded: new Date('2020-11-20'),
//               isSoldOut: false,
//               isPopular: false,
//               isOnSale: false,
//             },
//           ],
//         },
//         {
//           id: 'treats',
//           title: 'treats',
//           path: 'small-pets/treats',
//           items: [],
//         },
//         {
//           id: 'supplies',
//           title: 'supplies',
//           path: 'small-pets/supplies',
//           items: [],
//         },
//       ],
//     },
//     {
//       id: 'fish',
//       title: 'fish',
//       path: 'fish',
//       subPetCollections: [
//         {
//           id: 'food',
//           title: 'food',
//           path: 'fish/food',
//           items: [
//             {
//               id: nanoid(),
//               mainCollectionId: 'fish',
//               subCollectionId: 'food',
//               category: 'food',
//               name: 'fish food 1',
//               price: 10,
//               brand: '890',
//               shortDescription: 'Awesome!',
//               dateAdded: new Date('2020-11-20'),
//               isSoldOut: false,
//               isPopular: false,
//               isOnSale: false,
//             },
//             {
//               id: nanoid(),
//               mainCollectionId: 'fish',
//               subCollectionId: 'food',
//               category: 'food',
//               name: 'fish food 2',
//               price: 12,
//               brand: '90A',
//               shortDescription: 'Awesome!',
//               dateAdded: new Date('2020-09-15'),
//               isSoldOut: false,
//               isPopular: false,
//               isOnSale: false,
//             },
//             {
//               id: nanoid(),
//               mainCollectionId: 'fish',
//               subCollectionId: 'food',
//               category: 'food',
//               name: 'fish food 3',
//               price: 8,
//               brand: '0AB',
//               shortDescription: 'Awesome!',
//               dateAdded: new Date('2020-09-15'),
//               isSoldOut: false,
//               isPopular: false,
//               isOnSale: false,
//             },
//             {
//               id: nanoid(),
//               mainCollectionId: 'fish',
//               subCollectionId: 'food',
//               category: 'food',
//               name: 'fish food 4',
//               price: 16,
//               brand: 'ABC',
//               shortDescription: 'Awesome!',
//               dateAdded: new Date('2020-09-15'),
//               isSoldOut: false,
//               isPopular: false,
//               isOnSale: false,
//             },
//             {
//               id: nanoid(),
//               mainCollectionId: 'fish',
//               subCollectionId: 'food',
//               category: 'food',
//               name: 'fish food 5',
//               price: 20,
//               brand: 'BCD',
//               shortDescription: 'Awesome!',
//               dateAdded: new Date('2020-09-15'),
//               isSoldOut: false,
//               isPopular: false,
//               isOnSale: false,
//             },
//           ],
//         },
//         {
//           id: 'care',
//           title: 'care',
//           path: 'fish/care',
//           items: [],
//         },
//         {
//           id: 'supplies',
//           title: 'supplies',
//           path: 'fish/supplies',
//           items: [],
//         },
//       ],
//     },
//   ],
// };

export default initialCollections;
